import {Component, OnInit} from '@angular/core';
import {CargoServices} from '../../CoreModule/services/cargo.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {GrupoCargoEntity} from '../../CoreModule/entities/cargo.entity';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'grupo-cargo-list',
  templateUrl: '../templates/grupoCargo/grupo.cargo.list.template.html'
})
export class GrupoCargosCrudComponent implements OnInit {

  public grupos: GrupoCargoEntity[] = [];

  constructor(private cs: CargoServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.cs.getGruposCargos().subscribe((d: any) => {
      this.spinner.hide();
      console.log(d);
      this.grupos = d.data.gruposCargos;
    });
  }
}

@Component({
  selector: 'grupo-cargo-new',
  templateUrl: '../templates/grupoCargo/grupo.cargo.new.template.html'
})
export class NewGrupoCargoComponent implements OnInit {

  public grupo: GrupoCargoEntity = new GrupoCargoEntity();
  public tiendas: TiendaEntity[] = [];

  constructor(private cs: CargoServices, private ts: TiendaServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
      this.tiendas = this.tiendas.filter(t => t.activo == 1);
      this.spinner.hide();
    });
  }

  guardarGrupo() {
    this.spinner.show();
    this.cs.newGrupoCargo(this.grupo).subscribe(d => {
      console.log(d);
      this.spinner.hide();
      alert('Grupo Cargo creado con exito');
    });
  }
}

@Component({
  selector: 'grupo-cargo-edit',
  templateUrl: '../templates/grupoCargo/grupo.cargo.edit.template.html'
})
export class EditGrupoCargoComponent implements OnInit {
  public tiendas: TiendaEntity[] = [];

  public grupo: GrupoCargoEntity;

  constructor(private cs: CargoServices, private ts: TiendaServices, private spinner: NgxSpinnerService, private activeRouter: ActivatedRoute) {
  }

  ngOnInit(): void {
    let id = this.activeRouter.snapshot.params.id;
    this.spinner.show();
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;


      this.tiendas = this.tiendas.filter(t => t.activo == 1);

      this.tiendas.sort((a,b)=>{
        if(a.nombre > b.nombre)
          return 1;
        if(a.nombre < b.nombre)
          return -1;

        return 0;
      });

      this.cs.getGrupoCargo(id).subscribe((d2: any) => {
        console.log(d2);
        this.grupo = d2.data.grupoCargo;
        this.spinner.hide();
      });



    });
  }

  guardarGrupo() {
    this.spinner.show();
    this.cs.editGrupoCargo(this.grupo).subscribe(d => {
      this.spinner.hide();
      alert('Grupo Cargo actualizado con exito');
    });
  }
}
